/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Tooltip } from '@scuf/common';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import React from 'react';
import {
  EnergyDisaggregation,
  IAny,
  IRequestContext
} from '../../DashboardKPIWidgets/IEnergyManagementProps';
import TruncateText from '../TruncatedText/TruncateText';
import { IntervalType, MAGIC_VALUE } from '../Utils/Constants';
import {
  graphValueNILM,
  graphValueNILMTable,
  timeFormat
} from '../Utils/Utils';

import TruncateTextForNILMDisaggregation from '../TruncatedText/TruncateTextForNILMDisaggregation';

export interface IColumnConfig {
  sortable: boolean | undefined;
  header: IAny;
  field: string;
  width: string;
  align?: 'left' | 'center';
  renderer: (celldata: ICellData) => JSX.Element;
}
const header = (index: number, month: string) => {
  return (
    <>
      <div>{`${month}`}</div>
      <div className="ActualHeader">Actual</div>
    </>
  );
};

const headerForEquipmentType = () => {
  return <>Equipment Type</>;
};

export const getColumnDetails = (
  energyDisaggregation: Array<EnergyDisaggregation>,
  interValType?: IAny,
  requestContext?: IRequestContext,
  lng?: string
): IColumnConfig[] => {
  let value = graphValueNILMTable(energyDisaggregation, interValType, lng);
  const scope1TableColumns = value.monthIndex.map((month, index) => {
    let TimeFormateChange;
    if (interValType === IntervalType.Hourly) {
      TimeFormateChange =
        requestContext?.context?.timeFormat === 'HH:mm'
          ? month
          : timeFormat(month);
    } else {
      TimeFormateChange = month;
    }

    return {
      sortable: true,
      header: header(index, TimeFormateChange),
      field: TimeFormateChange,
      width: `7.25rem`,
      align: 'center' as IAny,
      renderer: renderMonthlyEmission
    };
  });

  scope1TableColumns.unshift({
    sortable: true,
    header: headerForEquipmentType(),
    field: 'EquipmentType',
    width: '12.5rem',
    align: 'left',
    renderer: renderCell
  });

  return scope1TableColumns as IAny;
};

export const renderMonthlyEmission = (celldata: ICellData) => {
  return (
    <div>
      {celldata.value}{' '}
      {celldata.value === null || celldata.value === undefined
        ? '---'
        : celldata.rowData.unit}
    </div>
  );
};

export const renderCell = (celldata: ICellData) => {
  return (
    <>
      <div
        className="equipmentNameColor"
        style={{ backgroundColor: celldata.rowData.color }}
      ></div>
      <TruncateTextForNILMDisaggregation
        text={celldata.rowData.name}
        maxLength={MAGIC_VALUE.EIGHTEEN}
      />
    </>
  );
};
